import axios from 'axios';
import qs from "qs";

const getCourseCheckin = ({url,id}) => axios.get(`${url}/index.php?r=session/getData&course_id=${id}`);
const setCourseCheckin = ({url,id,data}) => axios.post(`${url}/index.php?r=session/setData&course_id=${id}`, qs.stringify({data: data}));
const deleteCourseCheckin = ({url,id}) => axios.post(`${url}/index.php?r=session/deleteData&id=${id}`);


export default {
    getCourseCheckin,
    setCourseCheckin,
	deleteCourseCheckin
};
